import React from "react";
import AdminRankUpgrades from "./AdminRankUpgrades";

export default function AdminDigitalEducationPrimeApprovals() {
  return (
    <AdminRankUpgrades
      title="Approvals: Digital Education Prime"
      defaultStatus="INITIATED"
    />
  );
}
